import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=db9c3214"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=db9c3214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports